import { FONT } from "@/styles/common";
import { Text } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomTitle = styled(Text)<{ pensionIdx?: string }>`
    & p {
        ${({ pensionIdx }) => (pensionIdx === "2017" ? FONT("pretendard", 40, 700) : FONT("cormorant", 40, 600))}

        @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
            ${FONT("cormorant", 24, 500)}
        }
    }
`;

export const CustomSubTitle = styled(Text)`
    ${FONT("notoSerif", 20, 300)}

    @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
        ${FONT("notoSerif", 16, 300)}
    }
`;

export const CustomText = styled(Text)`
    ${FONT("pretendard", 16, 300)}

    @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
        ${FONT("pretendard", 14, 300)}
    }
`;
